export default __webpack_public_path__ + "static/media/icon-participants.e6043e53.svg";